import {Component} from '@angular/core';
import {CloudinaryOptions, CloudinaryUploader} from 'ng2-cloudinary';
import {NgForm} from '@angular/forms';
import {Router, ActivatedRoute} from "@angular/router";
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import {ToastrService} from 'toastr-ng2';
@Component({
    selector: 'app-add-tags',
    templateUrl: './add-tags.component.html',
    styleUrls: ['./add-tags.component.scss']
})
export class AddTagsComponent {

    tag: any = {
        tags: ''
    };
    tagData: FirebaseListObservable<any>;


    constructor(public af: AngularFireDatabase, public router: Router, public toastr: ToastrService) {
        this.tagData = af.list('/tags');
    }

    onSubmitTag(form: NgForm) {
        this.tagData.push(this.tag).then((res) => {
            this.router.navigate(['/tags/all']);
            this.toastr.success('Tags Added Successfully!', 'Success!');
        })
    }
     cancel(){
       this.router.navigate(['/tags/all']);
    }
}




// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/tags/add-tags/add-tags.component.ts